import { createSlice } from '@reduxjs/toolkit';

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState: {
    configuration: 'Select Configuration',
    filteredVideo: []
  },
  reducers: {
    setConfiguration: (state, action) => {
      state.configuration = action.payload;
    },
    setFilteredVideos: (state, action) => {
      state.filteredVideo = action.payload;
    }
  }
});

export const { setConfiguration, setFilteredVideos } =
  configurationSlice.actions;

export default configurationSlice.reducer;
